import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'

function CSFPage({ children }: IPageBehaviorComponentProps) {
  useEffect(() => {
    if (window.scrollY > 650) {
      document.getElementById('site-header')?.classList.add('header--fixed')
    }
  })

  return <>{children}</>
}

export default CSFPage
